import { LoaderFunctionArgs, json } from "@remix-run/node"
import { Link, useLoaderData } from "@remix-run/react"
import showdown from "showdown"
import Header from "~/components/header"
import Typography from "~/components/typography"
import { Button } from "~/components/ui/button"
import { Public } from "~/utils/remix"

export const loader = Public(async ({ request, context }: LoaderFunctionArgs) => {
  const converter = new showdown.Converter()

  return json({})
})

export default function VideoShare() {
  const data = useLoaderData<typeof loader>()

  return (
    <div className="max-w-5xl m-auto mt-16">
      <Header title="Share your #RealWorldSex">
        <Link to="/videos/create">
          <Button>Share Your Video</Button>
        </Link>
      </Header>
      <div className="mx-4 md:mx-16">
        <div className="grid grid-cols-1 md:grid-cols-2 mt-12 gap-12">
          <div className="flex justify-center items-center">
            <iframe
              className="aspect-video w-full rounded-lg shadow-lg overflow-hidden"
              src="https://www.youtube.com/embed/SuQ7CH_YBaA?si=5hzhzuiSfJ3u_qyB"
              frameBorder="0"
              allowFullScreen></iframe>
          </div>
          <Typography>
            <h2>Join the #SocialSexRevolution!</h2>
            <p>
              Join our diverse community of MakeLoveNotPornstars, share your <b>#RealWorldSex</b>, and earn{" "}
              <b>#RealWorldCash!</b>
            </p>
            <p>
              To learn more reach out to our curators at{" "}
              <Link to="mailto:curators@makelovenotporn.com">curators@makelovenotporn.com</Link>!
            </p>
            <p>
              For tips and tricks on filming your <b>#RealWorldSex</b> for MakeLoveNotPorn, check out our{" "}
              <Link to="/makelovenotpornstar-resources">MakeLoveNotPornstar resources</Link>!
            </p>
          </Typography>
          <Typography>
            <h2>What do you curate for?</h2>
            <p>
              We’re social sex -which is about doing what you already do on every social platform: capturing what’s
              happening as it happens, in all it’s funny messy wonderful glorious humanness.
            </p>
            <p>
              Your video is perfect for MLNP if it shows the sex you have in your everyday life naturally and
              spontaneously, without performing for the camera. #RealWorldSex isn’t about a specific activity, or mood,
              it’s about prioritizing the pleasure of the people in the video.
            </p>
            <p>
              We have videos that are #joyful, #passionate, #loving, #intense, #cuddly, and sometimes even a little bit
              #silly, and we can’t wait to share yours next!
            </p>
          </Typography>
          <Typography>
            <h2>The Rules</h2>
            <ol>
              <li>
                Everyone involved in creating your video must be over 18 and must provide two forms of ID to validate
                this. Including the person behind the camera
              </li>
              <li>
                You must have all the necessary rights and permissions for uploading this video, and it must not
                infringe on any third party copyrights, so make sure any music in the video is royalty-free.
              </li>
              <li>No children, no poop, no animals.</li>
            </ol>
            <Link to="/videos/create">
              <Button size="lg" className="mx-auto w-full py-6 mt-6 text-lg">
                Share Your Video
              </Button>
            </Link>
          </Typography>
        </div>
      </div>
    </div>
  )
}
